// Header Nav 语系切换统一处理
import { editLanguage } from '@/api/affiliate'

export default {
  computed: {
    currentLanguage() {
      for (const item of this.navLangList) {
        if (item.value === this.lang) {
          return item.label
        }
      }
      return ''
    }
  },
  data() {
    return {
      navLangList: [{
        value: 'en',
        label: 'English'
      }, {
        value: 'zh-tw',
        label: '繁體中文（台灣）'
      }, {
        value: 'ja',
        label: '日本語'
      }, {
        value: 'ko',
        label: '한국어'
      }],
      lang: localStorage.getItem('lang') || 'en'
    }
  },
  methods: {
    changeNavLanguage(locale, from) {
      // 切换语系
      this.$i18n.locale = locale
      localStorage.setItem('lang', locale)
      this.lang = locale
      // 保存切换的语系
      // 切换语系后，重整页面（公共数据也需要对应的语系数据）
      if (from === 'affiliate') {
        editLanguage().then(() => {})
      }
      if (from === 'home') {
        this.$router.push(`/${locale}`)
        return
      }
      this.$router.go(0)
    }
  }
}
